import React from 'react';
import VendorStepLogin from "../VendorStepLogin";
import IconName from "../../../svgLogo/SvgLogo";
import HeaderResponsive from "../HeaderResponsive";
import {Link} from "react-router-dom";

const VendorLogin = () => {
    return (
        <div className="vendor-login-wrapper">
            <div className="row">
                <div className="col-lg-5 order-2 order-lg-1">
                    <VendorStepLogin/>
                </div>
                <div className="col-lg-7 order-1 order-lg-2">
                    <HeaderResponsive/>
                    <form className="login-form d-flex flex-column align-items-center">
                        <div className="login-inputs-box">
                            <div className="login-input position-relative">
                                <input type="email" placeholder="ایمیل خود را وارد کنید"/>
                                <IconName name="email" className="icon input-icon position-absolute"/>
                            </div>
                            <div className="login-input position-relative xmt-8">
                                <IconName name="remove_red_eye" className="icon password-icon position-absolute password-vendor-login-icon"/>
                                <input type="password" placeholder="کلمه عبور خود را وارد کنید" id="password-input-vendor-login"/>
                                <IconName name="vpn_key" className="icon input-icon position-absolute"/>
                            </div>
                            <div className="login-input position-relative xmt-8">
                                <input type="number" placeholder="شماره موبایل خود را وارد کنید"/>
                                <IconName name="phone" className="icon input-icon position-absolute"/>
                            </div>
                        </div>
                        <Link to="/vendorLoginCode" type="submit" className="button-login xmt-12 xmt-lg-16">ثبت‌ نام</Link>
                        <div className="login-text xmt-3"><span className="text">قبلا ثبت‌نام کرده‌ام</span> <a href="#"
                                                                                                                className="login">ورود</a>
                        </div>
                        <div className="warning-login-text xmt-12">
                            <p className="text">
                                توجه: در صورتی که مراحل ثبت نام را نیمه تمام گذاشته اید، می توانید با همان ایمیل ثبت نام
                                خود را ادامه دهید.
                            </p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default VendorLogin;
